import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeeniconComponent } from './keenicon/keenicon.component';
import { FilterUserPipe } from './pipes/filter-users.pipe';
import { TimezoneDatePipe } from './pipes/timezone-date.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    KeeniconComponent,
    FilterUserPipe,
    TimezoneDatePipe, // Ensure this is declared only once
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    KeeniconComponent,
    FilterUserPipe,
    TimezoneDatePipe, // Ensure this is exported if used in other modules
  ],
})
export class SharedModule {}
